const asyncForEach = async <T,>(array: T[], callback: (item: T) => any) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index])
  }
}

export class CrudConnectorsPartner360 {
  public static fetchCetificates = async (items: any[]): Promise<any[]> => {
    const resultArr: any[] = []
    await asyncForEach(items, async (item) => {
      if (!resultArr.find((el) => el.Name === item.Name)) {
        resultArr.push({
          ...item,
          Files: [{ EntryId: item.EntryId, File: item.File }],
          EntryIds: [item.EntryId],
          ProofUploaded: item.File ? 'Yes' : 'No',
        })
      } else {
        resultArr.splice(
          0,
          resultArr.length,
          ...resultArr.map((el) => {
            if (el.Name === item.Name) {
              return {
                ...el,
                EntryIds: [...el.EntryIds, item.EntryId],
                Files: [...el.Files, { EntryId: item.EntryId, File: item.File }],
              }
            }
            return { ...el }
          })
        )
      }
      return
    })
    return resultArr
  }
}
